import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});
  const [footer, setFooter] = useState({});

  const load = useCallback(async () => {
    try {
      const [c, f] = await Promise.all([api.get("/content"), api.get("/footer")]);
      setContent(c.data || {});
      setFooter(f.data || {});
    } catch {}
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const t = (key, fallback = "") => content[key] ?? fallback;

  return (
    <ContentContext.Provider value={{ content, footer, t, reload: load }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);
